import { Route } from "react-router-dom";
import { url } from "./Config";

import React from "react";
import ChangePassword from "../Components/Auth/ChangePassword";

import Dashboard from "../Components/Dashboard/Dashboard";
import CustomerManagement from '../Components/CustomerManagement/CustomerManagement'
import EditProfile from "../Components/Profile/EditProfile";
import Service from "../Components/Service/Service";
import Category from "../Components/Category/Category";
import CategoryAdd from "../Components/Category/CategoryAdd";
import ServiceAdd from "../Components/Service/ServiceAdd";
import Salon from "../Components/SalonManagement/Salon";
import CustomerView from "../Components/CustomerManagement/CustomerView";
import SalonDetails from "../Components/SalonManagement/SalonDetails";
import CmsPages from "../Components/CmsPages/CmsPages";
import CmsPagesUpdate from "../Components/CmsPages/CmsPagesEdit";
import StaffManagement from "../Components/StaffManagement/StaffManagement";
import Contact from "../Components/Contact_US/Contact";
import Contactdetails from "../Components/Contact_US/Contactdetails";
import FaqManagementAdd from "../Components/FaqManagement/FaqManagementAdd";
import FaqManagementList from "../Components/FaqManagement/FaqManagementList";
import FaqManagementEdit from "../Components/FaqManagement/FaqManagementEdit";
import AttribsManagementAdd from "../Components/AttribsManagement/AttribsManagementAdd";
import AttribsManagementEdit from "../Components/AttribsManagement/AttribsManagementEdit";
import AttribsManagementList from "../Components/AttribsManagement/AttribsManagementList";
import BookingMangementList from "../Components/BookingMangement/BookingMangementList";
import BookingDetails from "../Components/BookingMangement/BookingDetails";
import SalonEdit from "../Components/SalonManagement/SalonEdit";
import CategoryEdit from "../Components/Category/CategoryEdit";
import CancelManagementList from "../Components/CancelManagement/CancelManagementList";
import CancelManagementAdd from "../Components/CancelManagement/CancelManagementAdd";
import CancelManagementEdit from "../Components/CancelManagement/CancelManagementEdit";
import EmailManagementList from "../Components/EmailMManagement/EmailManagementList";
import EmailManagementEdit from "../Components/EmailMManagement/EmailManagementEdit";
import ReviewRating from "../Components/ReviewRating/ReviewRating";
import Notifications from "../Components/Notifications/Notifications";
import NotificationAdd from "../Components/Notifications/NotificationAdd";
import SubscriptionPlansList from "../Components/SubscriptionPlans/SubscriptionPlansList";
import SubscriptionPlanView from "../Components/SubscriptionPlans/SubscriptionPlanView";
import SubscriptionPlanEdit from "../Components/SubscriptionPlans/SubscriptionPlanEdit";
import SubscriptionPaymentRequestsList from "../Components/SubscriptionPayments/SubscriptionPaymentRequestsList";
import SubscriptionTransactionHistoryList from "../Components/SubscriptionPayments/SubscriptionTransactionHistoryList";
import OfflineBankSettingsEdit from "../Components/SubscriptionPayments/OfflineBankSettingsEdit";
const routes = [
  {
    path: url + '/dashboard',
    element: <Dashboard />,
  },
  {
    path: url + '/change-password',
    element: <ChangePassword />,
  },
 
  {
    path: url + '/customer-management-list',
    element: <CustomerManagement />,
  },
  {
    path: url + '/edit-profile',
    element: <EditProfile />,
  },
  {
    path: url + '/service',
    element: <Service />,
  },
  {
    path: url + '/category',
    element: <Category />,
  },
  {
    path: url + '/category-edit/:id',
    element: <CategoryEdit />,
  },
  {
    path: url + '/category-add',
    element: <CategoryAdd />,
  },
  {
    path: url + '/service',
    element: <Service />,
  },
  {
    path: url + '/service-details/:id',
    element: <ServiceAdd />,
  },
  {
    path: url + '/salon-list',
    element: <Salon />,
  },

  {
    path: url + '/salon-edit/:id',
    element: <SalonEdit />,
  },

  {
    path: url + '/salon-details/:id',
    element: <SalonDetails />,
  },
  {
    path: url + '/customer-details/:id',
    element: <CustomerView />,
  },
  {
    path: url + '/cms-page',
    element: <CmsPages />,
  },
  {
    path: url + '/cms-pages/edit/:id',
    element: <CmsPagesUpdate />,
  },
  {
    path: url + '/staff-list',
    element: <StaffManagement />,
  },
    {
    path: url + '/contact-us/:id',
    element: <Contactdetails />,
  },
  {
    path: url + '/contact-us',
    element: <Contact />,
  },
  {
    path: url + '/faq-list',
    element: <FaqManagementList />,
  },
  {
    path: url + '/faq-add',
    element: <FaqManagementAdd />,
  },
  {
    path: url + '/faq-edit/:id',
    element: <FaqManagementEdit />,
  },
  {
    path: url + '/atribute-list',
    element: <AttribsManagementList />,
  },
  {
    path: url + '/atribute-add',
    element: <AttribsManagementAdd />,
  },
  {
    path: url + '/atribute-edit/:id',
    element: <AttribsManagementEdit />,
  },
  {
    path: url + '/booking-list',
    element: <BookingMangementList />,
  },
  {
    path: url + '/booking-detail/:id',
    element: <BookingDetails />,
  },
  {
    path: url + '/cancel-management-list',
    element: <CancelManagementList/>,
  },
  {
    path: url + '/cancel-management-add',
    element: <CancelManagementAdd/>,
  },
  {
    path: url + '/cancel-management-edit/:id',
    element: <CancelManagementEdit/>,
  },
  {
    path: url + '/email-template',
    element: <EmailManagementList/>,
  },
  {
    path: url + '/email-template/edit/:id',
    element: <EmailManagementEdit/>,
  },
  {
    path: url + '/review-rating-list',
    element: <ReviewRating/>,
  },
  {
    path: url + '/notifications',
    element: <Notifications/>,
  },
  {
    path: url + '/notification-add',
    element: <NotificationAdd/>,
  },
  {
    path: url + '/subscription-plans',
    element: <SubscriptionPlansList />,
  },
  {
    path: url + '/subscription-plan-view/:id',
    element: <SubscriptionPlanView />,
  },
  {
    path: url + '/subscription-plan-edit/:id',
    element: <SubscriptionPlanEdit />,
  },
  {
    path: url + '/subscription-payment-requests',
    element: <SubscriptionPaymentRequestsList />,
  },
  {
    path: url + '/subscription-transaction-history',
    element: <SubscriptionTransactionHistoryList />,
  },
  {
    path: url + '/offline-bank-settings',
    element: <OfflineBankSettingsEdit />,
  },
];

export const routeComponents = routes.map((route, index) => (
  <Route key={index} path={route.path} element={route.element} />
));